import axios, {AxiosInstance} from 'axios';
// Axios interceptors don't run inside a React render so they can't use
// App.useApp() — keep the static message API here. Components have been
// migrated to App.useApp() everywhere else to silence the antd v5
// "Static function can not consume context" warning.
import {message} from 'antd';
import appConfig from "../config";

const LOGIN_PATH = '/users/login';

const instance: AxiosInstance = axios.create({
    baseURL: appConfig.apiURL,
    headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
    },
    withCredentials: true
});

instance.interceptors.request.use((config) => {
    const token = localStorage.getItem('token');
    if (token) {
        config.headers = config.headers ?? {};
        (config.headers as any).Authorization = `Bearer ${token}`;
    }
    return config;
});

let sessionExpiredHandled = false;

instance.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error?.response?.status === 401) {
            const hadToken = !!localStorage.getItem('token');
            if (hadToken && !sessionExpiredHandled) {
                sessionExpiredHandled = true;
                localStorage.removeItem('token');
                delete instance.defaults.headers.common["Authorization"];
                message.warning('Session expirée. Merci de vous reconnecter.', 3);
                if (window.location.pathname !== LOGIN_PATH) {
                    setTimeout(() => {
                        if (window.location.pathname !== LOGIN_PATH) {
                            window.location.href = LOGIN_PATH;
                        }
                    }, 600);
                }
            }
        }
        return Promise.reject(error);
    }
);

export const setAuthToken = (token: string) => {
    console.log('setAuthToken', token);
    localStorage.setItem('token', token);
    if (token) {
        sessionExpiredHandled = false;
        try {
            instance.defaults.headers.common["Authorization"] = `Bearer ${token}`;
        }
        catch (error) {
            console.error(error);
        }
    } else
        delete instance.defaults.headers.common["Authorization"];
}

export default instance;